<template>
    <form class="card">
        <h3>Расписание</h3>
        <Timetable v-if="status == ''" :data.sync="data"></Timetable>
    </form>
</template>

<script>
    import Timetable from '@/components/forms/Timetable.vue'
    export default {
        props: ['status', 'data'],
        components: {
            Timetable
        },
        created () {
            this.$emit('getData')
        }
    }
</script>